import { getRibbonToastSeverityColor, isRibbonToastSticky } from '@mi-front/ui';
import { getNotificationWorkflow } from '../workflows';

export type NotificationSeverity = 'error' | 'warning' | 'success' | 'info';

/**
 * Maps a Knock workflow key to UI severity for toasts and feed accents.
 */
export function getNotificationSeverity(workflowKey: string | undefined): NotificationSeverity {
  return getNotificationWorkflow(workflowKey)?.severity ?? 'info';
}

/**
 * Theme palette path for the severity ribbon / accents.
 */
export function getNotificationSeverityColor(severity: NotificationSeverity): string {
  return getRibbonToastSeverityColor(severity);
}

/**
 * Whether a Knock toast stays open until dismissed (error/warning).
 * Also selects contained button vs clickable Paper + cue for the primary action.
 */
export function isNotificationToastSticky(severity: NotificationSeverity): boolean {
  return isRibbonToastSticky(severity);
}

/**
 * Whether a realtime feed item should show a toast.
 * Explicit workflow `toast` wins; when omitted, error/warning default to true and success/info to false.
 */
export function shouldShowNotificationToast(
  toast: boolean | undefined,
  severity: NotificationSeverity,
): boolean {
  if (toast !== undefined) {
    return toast;
  }
  return isNotificationToastSticky(severity);
}
